'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useSession } from '@/lib/auth-client';
import { useUserReactions, useAddReaction, useRemoveReaction, useEngagementSummary } from '@/lib/hooks';
import { getAvailableReactions, getReactionEmoji, getReactionMode } from '@/lib/config/reactions';
import { ReactionButton } from './ReactionButton';
import { ReactionDialog } from './ReactionDialog';
import { Pencil } from 'lucide-react';
interface ReactionBarProps {
  objectId: string;
  objectType: 'item' | 'collection' | 'entity' | 'collection_item' | 'submission' | 'initiative' | 'content';
  dialogEnabled?: boolean;
  title?: string;
  details?: React.ReactNode;
}
export function ReactionBar(t0) {
  const $ = _c(60);
  const {
    objectId,
    objectType,
    dialogEnabled: t1,
    title,
    details
  } = t0;
  const dialogEnabled = t1 === undefined ? false : t1;
  const {
    data: session
  } = useSession();
  let t2;
  if ($[0] !== session?.user?.id) {
    t2 = session?.user?.id?.toString();
    $[0] = session?.user?.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const currentUserId = t2;
  const [dialogOpen, setDialogOpen] = useState(false);
  const {
    data: t3
  } = useUserReactions(currentUserId || "", objectId, objectType);
  let t4;
  if ($[2] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const userReactions = t4;
  const {
    data: engagementSummary
  } = useEngagementSummary(objectId, objectType);
  const addReaction = useAddReaction();
  const removeReaction = useRemoveReaction();
  let availableReactions;
  let handleReactionClick;
  let isSignedIn;
  let reactionMode;
  let t5;
  let t6;
  if ($[4] !== addReaction || $[5] !== currentUserId || $[6] !== engagementSummary?.engagement?.reactions?.by_type || $[7] !== objectId || $[8] !== objectType || $[9] !== removeReaction || $[10] !== session?.user || $[11] !== userReactions) {
    availableReactions = getAvailableReactions(objectType);
    let t7;
    if ($[18] !== objectType) {
      t7 = getReactionMode(objectType);
      $[18] = objectType;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    reactionMode = t7;
    let t8;
    if ($[20] !== addReaction || $[21] !== currentUserId || $[22] !== objectId || $[23] !== objectType || $[24] !== removeReaction || $[25] !== userReactions) {
      t8 = async reactionType => {
        if (!currentUserId) {
          return;
        }
        const hasReaction = userReactions.includes(reactionType);
        let response;
        if (hasReaction) {
          response = await removeReaction.mutateAsync({
            actorId: currentUserId,
            objectId,
            objectType,
            reactionType
          });
        } else {
          response = await addReaction.mutateAsync({
            objectId,
            objectType,
            reactionType
          });
        }
        console.log({
          response
        });
      };
      $[20] = addReaction;
      $[21] = currentUserId;
      $[22] = objectId;
      $[23] = objectType;
      $[24] = removeReaction;
      $[25] = userReactions;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    handleReactionClick = t8;
    let t9;
    if ($[27] !== engagementSummary?.engagement?.reactions?.by_type) {
      t9 = reactionType_0 => engagementSummary?.engagement?.reactions?.by_type?.[reactionType_0]?.count || 0;
      $[27] = engagementSummary?.engagement?.reactions?.by_type;
      $[28] = t9;
    } else {
      t9 = $[28];
    }
    const getReactionCount = t9;
    isSignedIn = !!session?.user;
    t5 = "flex flex-wrap gap-1 items-center";
    let t10;
    if ($[29] !== getReactionCount || $[30] !== handleReactionClick || $[31] !== isSignedIn || $[32] !== objectType || $[33] !== userReactions) {
      t10 = reactionType_1 => <ReactionButton key={reactionType_1} reactionType={reactionType_1} count={getReactionCount(reactionType_1)} isActive={userReactions.includes(reactionType_1)} onClick={() => handleReactionClick(reactionType_1)} emoji={getReactionEmoji(objectType, reactionType_1)} disabled={!isSignedIn} />;
      $[29] = getReactionCount;
      $[30] = handleReactionClick;
      $[31] = isSignedIn;
      $[32] = objectType;
      $[33] = userReactions;
      $[34] = t10;
    } else {
      t10 = $[34];
    }
    t6 = availableReactions.map(t10);
    $[4] = addReaction;
    $[5] = currentUserId;
    $[6] = engagementSummary?.engagement?.reactions?.by_type;
    $[7] = objectId;
    $[8] = objectType;
    $[9] = removeReaction;
    $[10] = session?.user;
    $[11] = userReactions;
    $[12] = availableReactions;
    $[13] = handleReactionClick;
    $[14] = isSignedIn;
    $[15] = reactionMode;
    $[16] = t5;
    $[17] = t6;
  } else {
    availableReactions = $[12];
    handleReactionClick = $[13];
    isSignedIn = $[14];
    reactionMode = $[15];
    t5 = $[16];
    t6 = $[17];
  }
  let t7;
  if ($[35] !== dialogEnabled) {
    t7 = dialogEnabled && <button onClick={() => setDialogOpen(true)} className="text-sm text-gray-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-200 hover:underline transition-colors cursor-pointer"><Pencil className="size-4 mr-2" /></button>;
    $[35] = dialogEnabled;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  let t8;
  if ($[37] !== t5 || $[38] !== t6 || $[39] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[37] = t5;
    $[38] = t6;
    $[39] = t7;
    $[40] = t8;
  } else {
    t8 = $[40];
  }
  let t9;
  if ($[41] !== addReaction || $[42] !== availableReactions || $[43] !== details || $[44] !== dialogEnabled || $[45] !== dialogOpen || $[46] !== engagementSummary || $[47] !== handleReactionClick || $[48] !== isSignedIn || $[49] !== removeReaction || $[50] !== title || $[51] !== userReactions) {
    t9 = dialogEnabled && <div className="flex items-start"><ReactionDialog availableReactions={availableReactions} userReactions={userReactions} engagementSummary={engagementSummary} onReactionClick={handleReactionClick} isSignedIn={isSignedIn} isPending={addReaction.isPending || removeReaction.isPending} open={dialogOpen} onOpenChange={setDialogOpen} title={title} details={details} /></div>;
    $[41] = addReaction;
    $[42] = availableReactions;
    $[43] = details;
    $[44] = dialogEnabled;
    $[45] = dialogOpen;
    $[46] = engagementSummary;
    $[47] = handleReactionClick;
    $[48] = isSignedIn;
    $[49] = removeReaction;
    $[50] = title;
    $[51] = userReactions;
    $[52] = t9;
  } else {
    t9 = $[52];
  }
  let t10;
  if ($[53] !== reactionMode || $[54] !== userReactions) {
    t10 = reactionMode === "single" && userReactions.length > 0 && <p className="text-xs text-gray-500">Click another reaction to change yours</p>;
    $[53] = reactionMode;
    $[54] = userReactions;
    $[55] = t10;
  } else {
    t10 = $[55];
  }
  let t11;
  if ($[56] !== t10 || $[57] !== t8 || $[58] !== t9) {
    t11 = <div>{t8}{t9}{t10}</div>;
    $[56] = t10;
    $[57] = t8;
    $[58] = t9;
    $[59] = t11;
  } else {
    t11 = $[59];
  }
  return t11;
}